/* Core & libraries */
import React, { useCallback } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { CREDIT_REQUEST_HISTORY_GRID_TYPE } from "../creditRequestHistoryFilters";

/* Components */
import { ReactComponent as HourGlassSvg } from "resources/images/hourglass-cercle.svg";
import { ReactComponent as AlertCircleGridSvg } from 'resources/images/alert-circle-grid.svg';
import UCButton from "components/buttons";

/* Styles */
import styles from "./styles.js"

const MESSAGE_CONFIG = {
  [CREDIT_REQUEST_HISTORY_GRID_TYPE.APPROVED]: {
    title: "retro.grid.noData.approved.title",
    description: "retro.grid.noData.description",
  },
  [CREDIT_REQUEST_HISTORY_GRID_TYPE.PENDING]: {
    title: "retro.grid.noData.pending.title",
    description: "retro.grid.noData.description",
  },
  [CREDIT_REQUEST_HISTORY_GRID_TYPE.INELIGIBLE]: {
    title: "retro.grid.noData.ineligible.title",
    description: "retro.grid.noData.description",
  },
  [CREDIT_REQUEST_HISTORY_GRID_TYPE.FAILED]: {
    title: "retro.grid.noData.failed.title",
    description: "retro.grid.noData.description",
  },
};

const DEFAULT_MESSAGES = {
  title: "retro.grid.noData.search.title",
  description: "retro.grid.noData.search.description",
};

const CreditRequestHistoryNoData = (props = {}) => {
  const {gridOptions, setGridOptions} = props;
  const theme = useTheme();
  const classes = styles({theme});

  const setGridSearchTerm = useCallback(() => {
    setGridOptions(gridOptions => ({...gridOptions, page: 1, searchterm: undefined}))
  }, []);

  const renderIcon = () => {
    if (gridOptions?.searchterm) {
      return <AlertCircleGridSvg />
    } else {
      return <HourGlassSvg/>
    }
  }

  const renderHeader = ({ title, description }) => (
    <>
      <h1><FormattedMessage id={title} /></h1>
      <p><FormattedMessage id={description} /></p>
    </>
  );

  const renderText = () => {
    const { status, searchterm } = gridOptions || {};
    const messageSet = searchterm
      ? DEFAULT_MESSAGES
      : MESSAGE_CONFIG[status] ?? DEFAULT_MESSAGES;

    return renderHeader(messageSet);
  };

  return (
    <div className={classes.retroNoDataWrapper}>
      <div className={classes.logo}>
        {renderIcon()}
      </div>
      {renderText()}
      {gridOptions?.searchterm &&
        <UCButton
          type="default"
          variant="outline"
          onClick={setGridSearchTerm}
          className={classes.clearSearchButton}
        >
          <FormattedMessage id="retro.grid.header.clearButton"/>
        </UCButton>
      }
    </div>
  )
}

export default CreditRequestHistoryNoData;
